import type { Placement } from '@hc-frontend/core-types';
import type { SelfDescribingJson } from '@snowplow/browser-tracker';

import type {
  AdContextData,
  BuildAdContextProps,
} from './build-ad-context.types';

export function buildAdContext({
  searchMethod,
  productFit,
  adId,
  category,
  placement,
  impressionPosition,
  groupId,
  creativeId,
  creativeTitle,
  advertiserName,
  campaignName,
  productName,
}: BuildAdContextProps): SelfDescribingJson<AdContextData> {
  const data: AdContextData = {
    search_method: searchMethod,
    product_fit: productFit,
    ad_id: adId,
    category: category?.toLocaleLowerCase() as Lowercase<Placement>,
    placement,
    impression_position: impressionPosition,
    group_id: groupId?.toString(),
    creative_id: creativeId?.toString(),
    creative_title: creativeTitle,
    advertiser_name: advertiserName,
    campaign_name: campaignName,
    product_name: productName?.toLocaleLowerCase(),
  };

  return {
    schema: 'iglu:com.healthcare/ad/jsonschema/1-1-0',
    data,
  };
}
